// Навчальний рік семестру для підписів (топбар, фільтр груп). Список семестрів F — записи довідника semesters: вкладеного
// academicYear там немає, але є _refs.academicYearId { id, code, label } (рушій U01). Код семестру не зобов'язаний мати
// префікс року, тож сирий academicYearId (UUID) як підпис не показуємо ніколи.
import type { SemesterItem } from '@/app/semester';

interface RefDisplay {
  id?: unknown;
  code?: unknown;
  label?: unknown;
}

function refOf(s: SemesterItem): RefDisplay | null {
  const refs = (s as SemesterItem & { _refs?: Record<string, unknown> })._refs;
  const ref = refs?.academicYearId;
  return ref && typeof ref === 'object' && !Array.isArray(ref) ? (ref as RefDisplay) : null;
}

/** Код навчального року семестру: _refs довідника, вкладений зв'язок або префікс коду «РРРР-РРРР-N»; null — невідомо. */
export function semesterYearCode(s: SemesterItem): string | null {
  const ref = refOf(s);
  // рушій повертає { code: id }, якщо посилання не знайдено — це не код
  if (ref && typeof ref.code === 'string' && ref.code && ref.code !== s.academicYearId) return ref.code;
  if (s.academicYear?.code) return s.academicYear.code;
  const m = /^(\d{4}-\d{4})/.exec(s.code);
  return m ? m[1] : null;
}

/** Підпис навчального року: «2026/2027 навчальний рік»; код невідомий — назва з довідника або «Навчальний рік». */
export function semesterYearLabel(s: SemesterItem): string {
  const code = semesterYearCode(s);
  if (code) return `${code.replace('-', '/')} навчальний рік`;
  const ref = refOf(s);
  const label = typeof ref?.label === 'string' && ref.label !== s.academicYearId ? ref.label : null;
  return label ? `Навчальний рік ${label}` : 'Навчальний рік';
}
